import React from "react";

export interface ViewportSize {
  width: number;
  height: number;
}

/**
 * Tracks the browser viewport size, updating on window resize. Used to compute
 * which map content is currently on-screen for virtualization.
 */
export const useViewportSize = (): ViewportSize => {
  const [size, setSize] = React.useState<ViewportSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const onResize = () =>
      setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return size;
};
